<script setup lang="ts">
interface Props {
  label?: string
  value?: string | number
  showValue?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  label: '',
  value: '',
  showValue: true
})
</script>

<template>
  <div class="value-item">
    <div class="item-name">
      <slot name="label">{{ props.label }}</slot>
    </div>
    <div v-if="props.showValue" class="item-value">
      <slot>{{ props.value }}</slot>
    </div>
  </div>
</template>

<style scoped>
.value-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 4px;
}

.item-name {
  vertical-align: top;
  font-weight: 500;
  color: var(--el-text-color-secondary);
  font-size: 14px;
}

.item-value {
  color: var(--el-text-color-primary);
  font-size: 14px;
  text-align: right;
  word-break: break-word;
  max-width: 60%;
  white-space: pre-line;
}

/* Mobile responsive adjustments */
@media (max-width: 768px) {
  .value-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .item-value {
    text-align: left;
    max-width: 100%;
  }
}
</style>
